/**
 * File Detail API Response Types
 *
 * Matches the Smithy model: FintechLastMileBeaconSmithyModel/model/file.smithy
 * API: GET /file/{fileId} → { file: FileDetailData }
 */

/** Upstream Beacon ingestion source. */
export type FileDataSource = 'BIP_V1' | 'BIP_V2' | 'UAPI' | 'LMPS';

/** Direction relative to the merchant. */
export type FileDirection = 'OUTBOUND' | 'INBOUND';

/** Normalized file type (ISO 20022 message format). */
export type FileType = 'PAIN_001' | 'PAIN_002' | 'CAMT053' | null;

/** Lifecycle stage state. */
export type FileLifecycleState = 'IN_PROGRESS' | 'SUCCESS' | 'FAILED';

/** Key-value attributes per stage (batchIndex, pluginName, fileName, etc.) */
export type AttributeMap = Record<string, string>;

/** Detail for a single lifecycle stage. */
export interface FileStatusDetail {
  enteredAt: number | null;
  exitedAt: number | null;
  latencyMs: number | null;
  state: FileLifecycleState;
  paymentStatus: string;
  attributes: AttributeMap;
}

/** Full file detail returned by GET /file/{fileId}. */
export interface FileDetailData {
  id: string;
  dataSource: FileDataSource;
  fileType: FileType;
  direction: FileDirection;
  bank: string;
  createdAt: number;
  updatedAt: number;
  beaconTransmissionStatus: string;
  beaconTransmissionState: FileLifecycleState;
  statusMap: Record<string, FileStatusDetail>;
  paymentIds: string[];
  totalE2ELatencyMs: number | null;
}

/** Redux slice state for file detail. */
export interface FileDetailState {
  data: FileDetailData | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

export const fileDetailInitialState: FileDetailState = {
  data: null,
  status: 'idle',
  error: null,
};
